module.exports = __webpack_public_path__ + "images/manage-zaggle-fd1323603c1b7ff8880f0df301193215.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/manage-zaggle.png
// module id = ./client/assets/images/manage-zaggle.png
// module chunks = 86